import * as e from "react";
import t from "../lib/SSRBase.es.js";
import m from "../defs/Share.es.js";
const r = e.forwardRef((o, a) => /* @__PURE__ */ e.createElement(t, { ref: a, ...o, weights: m }));
r.displayName = "ShareIcon";
const f = r;
export {
  f as Share,
  r as ShareIcon
};
